'use client'
import { useState } from 'react'
import RegistrationForm, {
    Props as RegistrationFormProps,
} from '../Registration'
import Link from '../Link'
import EshopFormHeading from '../FormHeading'
import { useUser } from '@/eshop/hooks/useUser'
import { useRouter } from 'next/navigation'
import { useMutation } from '@tanstack/react-query'
import { LoginFormData, loginResponseSchema } from '@/eshop/utils/schema'
import { addTokenToCookie } from '@/eshop/utils/client'
import { useTranslation } from 'react-i18next'

interface Props extends Omit<RegistrationFormProps, 'onDone'> {}

export function RegistrationWrapper(props: Props) {
    const [isDone, setIsDone] = useState(false)
    const { t } = useTranslation()
    const user = useUser()
    const { push } = useRouter()

    const { mutate: logUser } = useMutation({
        mutationFn: (data: LoginFormData) =>
            fetch('/api/eshop/login', {
                method: 'POST',
                body: JSON.stringify(data),
            })
                .then((res) => res.json())
                .then((res) => loginResponseSchema.safeParse(res)),
        onSuccess: (body) => {
            if (body && body.success && body.data.status === 'success') {
                // setUser(body.data.data.user)
                addTokenToCookie(
                    body.data.data.token,
                    body.data.data.user.tokenExpiring
                )
                setTimeout(() => {
                    push('/eshop')
                    window.location.reload()
                }, 500)
            }
        },
    })

    if (user && !user.isAnonymous) {
        push('/eshop')
        return null
    }

    if (isDone) {
        return (
            <div className="mb-32">
                <EshopFormHeading size="large" className="mb-6">
                    {t('eshop.registration.title')}
                </EshopFormHeading>
                <div className="alert alert-success">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="stroke-current shrink-0 h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                    <span>{t('eshop.registration.successMsg')}</span>
                </div>
                <div className="text-center mt-6">
                    {t('eshop.registration.goToEshop')}{' '}
                    <Link href="/eshop">
                        {t('eshop.registration.homePage')}
                    </Link>
                    .
                </div>
            </div>
        )
    }

    return (
        <RegistrationForm
            {...props}
            onDone={(email, password) => {
                setIsDone(true)
                logUser({
                    email,
                    password,
                })
            }}
        />
    )
}
